var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
        staticClass: "row",
      },
      [
        _c(
          "p",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: 11,
                expression: "11",
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.reportStatusSid != null,
                expression: "reportStatusSid != null",
              },
            ],
          },
          [
            _c("span", {
              staticClass: "dot_status",
              style: { backgroundColor: _vm.statusColor },
            }),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "operationalData.filters.statuses." + _vm.reportStatusSid
                  )
                )
              ),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
        ],
        staticClass: "row",
      },
      [
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 4 },
                expression: "{ s: 12, l: 4 }",
              },
            ],
            attrs: {
              label: _vm.$t("operationalData.entryView.unitInformation.plant"),
            },
          },
          [
            _c("pui-form-input-field", {
              attrs: {
                type: "text",
                "is-disabled": true,
                "placeholder-text": _vm.activeUnitKPIModel.Site.Name,
              },
            }),
          ],
          1
        ),
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 4 },
                expression: "{ s: 12, l: 4 }",
              },
            ],
            attrs: { label: _vm.$t("unit") },
          },
          [
            _c("pui-form-input-field", {
              attrs: {
                type: "text",
                "is-disabled": true,
                "placeholder-text": _vm.activeUnitKPIModel.Unit.Name,
              },
            }),
          ],
          1
        ),
        _c(
          "pui-form-group",
          {
            directives: [
              {
                name: "pui-form-grid-column",
                rawName: "v-pui-form-grid-column",
                value: { s: 12, l: 4 },
                expression: "{ s: 12, l: 4 }",
              },
            ],
            attrs: {
              label: _vm.$t(
                "operationalData.entryView.unitInformation.netCapacity"
              ),
            },
          },
          [
            _c("custom-input", {
              attrs: { "is-disabled": true },
              model: {
                value: _vm.activeUnitKPIModel.NetCapacity,
                callback: function ($$v) {
                  _vm.$set(_vm.activeUnitKPIModel, "NetCapacity", _vm._n($$v))
                },
                expression: "activeUnitKPIModel.NetCapacity",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }